import { render } from "./CaseStudies.vue?vue&type=template&id=083085ee&scoped=true"
import script from "./CaseStudies.vue?vue&type=script&lang=js"
export * from "./CaseStudies.vue?vue&type=script&lang=js"

import "./CaseStudies.vue?vue&type=style&index=0&id=083085ee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083085ee"]])

export default __exports__